import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import "./navbar.scss";
import AuthContainer from "../../../store/container/AuthContainer";
import { withRouter } from "react-router-dom";
import appLogo from "../../../assets/logos/logo.svg";
import dashboardIcon from "../../../assets/icons/nav-icons/dashboard.svg";
import dashboardIconActive from "../../../assets/icons/nav-icons/dashboard-active.svg";
import instituteIcon from "../../../assets/icons/nav-icons/institute.svg";
import instituteIconActive from "../../../assets/icons/nav-icons/institute-active.svg";
import libraryIcon from "../../../assets/icons/nav-icons/content-library.svg";
import libraryIconActive from "../../../assets/icons/nav-icons/content-library-active.svg";
import courseIcon from "../../../assets/icons/nav-icons/course-structure.svg";
import courseIconActive from "../../../assets/icons/nav-icons/course-structure-active.svg";
import examIcon from "../../../assets/icons/nav-icons/exams.svg";
import examIconActive from "../../../assets/icons/nav-icons/exams-active.svg";
import liveClassIcon from "../../../assets/icons/nav-icons/live-classes.svg";
import liveClassIconActive from "../../../assets/icons/nav-icons/live-classes-active.svg";
import tutorsIcon from "../../../assets/icons/nav-icons/tutors.svg";
import tutorsIconActive from "../../../assets/icons/nav-icons/tutors-active.svg";
import studentsIcon from "../../../assets/icons/nav-icons/students.svg";
import studentsIconActive from "../../../assets/icons/nav-icons/students-active.svg";
import internalUsersIcon from "../../../assets/icons/nav-icons/internal-users.svg";
import internalUsersIconActive from "../../../assets/icons/nav-icons/internal-users-active.svg";
import analyticsIcon from "../../../assets/icons/nav-icons/analytics.svg";
import analyticsIconActive from "../../../assets/icons/nav-icons/analytics-active.svg";
import leaderboardIcon from "../../../assets/icons/nav-icons/leaderboard.svg";
import leaderboardIconActive from "../../../assets/icons/nav-icons/leaderboard-active.svg";

import activityIcon from "../../../assets/icons/nav-icons/activity.svg";
import activityIconActive from "../../../assets/icons/nav-icons/activity-selected.svg";

import * as appRoutes from "../../../routes/routeConstants/appRoutes";
import SubMenu from "antd/es/menu/SubMenu";
import avatarPlaceholder from "../../../assets/placeholder/avatar_placeholder.png";
import UserService from "../../../services/AuthService/auth.service";
import MyProfile from "../MyProfile";
import { SettingFilled, CodeFilled } from "@ant-design/icons";

const Navbar = (props: any) => {
  useEffect(() => {
    setUserDetails(props?.user);
  }, [props]);

  const [userDetails, setUserDetails] = useState<any>();
  const [showMyProfile, setProfileVisibility] = useState<boolean>(false);
  const handleLogout = () => {
    UserService.logoutUser(
      () => {
        localStorage.clear()
        props.setUnAuthenticated();
        props.history.push(appRoutes.LOGIN);
      },
      () => { },
      () => { }
    ).then();
  };

  return (
    !props.location.pathname.includes("auth") &&
    !props.location.pathname.includes("change-password") && (
      <>
        <MyProfile
          closeHandler={() => setProfileVisibility(false)}
          visible={showMyProfile}
          user={props?.user}
        />
        <div className="nav-sidebar">



          <Menu
            triggerSubMenuAction={"click"}
            mode="vertical"
            selectedKeys={[props?.location?.pathname?.split("/")[1]]}
          >

            <Menu.Item className="navbar-item logo" key="logo">
              <img src={appLogo} alt="mindjjo-logo" />
            </Menu.Item>

            <SubMenu
              key="sub2"
              icon={
                <img
                  src={userDetails?.displayPictureUrl || avatarPlaceholder}
                  alt=""
                  className="submenu-icon"
                />
              }
              // popupOffset={[-175, -75]} old
              title={userDetails?.fullName || "Admin"}
            >
              <Menu.Item key="7" onClick={() => setProfileVisibility(true)}>
                My Profile
              </Menu.Item>
              <Menu.Item
                key="8"
                onClick={() => props.history.push(appRoutes.CHANGE_PASSWORD)}
              >
                Change password
              </Menu.Item>
              <Menu.Item key="9" onClick={handleLogout}>
                Logout
              </Menu.Item>
            </SubMenu>



            <Menu.Item
              className="navbar-item"
              key="dashboard"
              onClick={() => props.history.push(appRoutes.DASHBOARD)}
            >
              <img
                src={
                  props?.location?.pathname.includes("dashboard")
                    ? dashboardIconActive
                    : dashboardIcon
                }
                alt=""
              />
              <span>Dashboard</span>
            </Menu.Item>
            <Menu.Item
              className="navbar-item"
              key="institute"
              onClick={() => props.history.push(appRoutes.INSTITUTE)}
            >
              <img
                src={
                  props?.location?.pathname.includes("institute")
                    ? instituteIconActive
                    : instituteIcon
                }
                alt=""
              />
              <span>Institute</span>
            </Menu.Item>

            {props?.user?.roleName === "admin" ?
              <React.Fragment>
                <Menu.Item
                  className="navbar-item"
                  key="content-library"
                  onClick={() => props.history.push(appRoutes.CONTENT_LIBRARY)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("content-library")
                        ? libraryIconActive
                        : libraryIcon
                    }
                    alt=""
                  />
                  <span>Content Library</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="courses"
                  onClick={() => props.history.push(appRoutes.COURSE_BOARDS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("courses")
                        ? courseIconActive
                        : courseIcon
                    }
                    alt=""
                  />
                  <span>Course Structure</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="exams"
                  onClick={() => props.history.push(appRoutes.EXAMS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("exams")
                        ? examIconActive
                        : examIcon
                    }
                    alt=""
                  />
                  <span>Exams</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="live-classes"
                  onClick={() => props.history.push(appRoutes.LIVE_CLASSES)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("live-classes")
                        ? liveClassIconActive
                        : liveClassIcon
                    }
                    alt=""
                  />
                  <span>Live Classes</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="tutors"
                  onClick={() => props.history.push(appRoutes.TUTORS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("tutors")
                        ? tutorsIconActive
                        : tutorsIcon
                    }
                    alt=""
                  />
                  <span>Tutors</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="students"
                  onClick={() => props.history.push(appRoutes.STUDENTS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("students")
                        ? studentsIconActive
                        : studentsIcon
                    }
                    alt=""
                  />
                  <span>Students</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="analytics"
                  onClick={() => props.history.push(appRoutes.ANALYTICS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("analytics")
                        ? analyticsIconActive
                        : analyticsIcon
                    }
                    alt=""
                  />
                  <span>Analytics</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="reports"
                  onClick={() => props.history.push(appRoutes.REPORTS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("reports")
                        ? activityIconActive
                        : activityIcon
                    }
                    alt=""
                  />
                  <span>Reports</span>
                </Menu.Item>

                <Menu.Item
                  className="navbar-item"
                  key="products"
                  onClick={() => props.history.push(appRoutes.PRODUCTS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("products")
                        ? activityIconActive
                        : activityIcon
                    }
                    alt=""
                  />
                  <span>Products</span>
                </Menu.Item>


                <Menu.Item
                  className="navbar-item"
                  key="internal-users"
                  onClick={() => props.history.push(appRoutes.INTERNAL_USERS)}
                >
                  <img
                    src={
                      props?.location?.pathname.includes("internal-users")
                        ? internalUsersIconActive
                        : internalUsersIcon
                    }
                    alt=""
                  />
                  <span>Internal Users</span>
                </Menu.Item>
                <Menu.Item
                  className="navbar-item"
                  key="generator"
                  onClick={() => props.history.push(appRoutes.GENERATOR)}
                >
                  {/* <img
                className="code-generator__icon"
                src={
                  props?.location?.pathname.includes("generator")
                    ? codeIconActive
                    : codeIcon
                }
                alt=""
              /> */}
                  <CodeFilled />
                  <span>Generator</span>
                </Menu.Item>

              </React.Fragment>
              : null
            }

            <Menu.Item
              className="navbar-item"
              key="leaderboard"
              onClick={() => props.history.push(appRoutes.LEADERBOARD)}
            >
              <img
                src={
                  props?.location?.pathname.includes("leaderboard")
                    ? leaderboardIconActive
                    : leaderboardIcon
                }
                alt=""
              />
              <span>Leaderboard</span>
            </Menu.Item>


          </Menu>
        </div>
      </>
    )
  );
};

export default withRouter(AuthContainer(Navbar));
